import { useEffect, useRef } from 'react';
import { useQuery as useApolloQuery } from '@apollo/client';
import { parseErrors } from 'src/utils/api/error';
import { getCloneData } from 'src/utils/data/clone';
import { notification } from 'src/components/Notification';

const useQuery = (query, params, shouldThrow = false, shouldReturnError = false) => {

  const errorToastId = useRef(null);
  const errorDisplayed = useRef(false);

  useEffect(() => {
    return () => {
      if (errorToastId.current) {
        notification.dismiss(errorToastId.current);
      }
    };
  }, []);

  const { error, ...rest } = useApolloQuery(query, {
    fetchPolicy: 'network-only',
    notifyOnNetworkStatusChange: true,
    ...params,
  });

  if (error) {
    if (shouldReturnError) {
      return { ...rest, error, data: null };
    }

    const message = parseErrors(error).join(', ');
    if (!shouldThrow) {
      if (!errorDisplayed.current) {
        if(message === 'The job is cancelled') errorToastId.current = notification.onErrorWithOK(message, 'OK', false);
        else  {
          errorToastId.current = notification.onQueryFailed(query, message, () => {
            errorDisplayed.current = false;
            rest.refetch();
          });
        }
        errorDisplayed.current = true;
      }

      return { ...rest, data: null };
    }

    throw new Error(message);
  }

  if (params && params.skip && !params.ignoreClone && query.definitions[0]) {
    const id = window.location.hash.substr(1);
    const name = query.definitions[0]?.name?.value;

    if (id && name) {
      return {
        data: {
          [name]: getCloneData(id),
        },
      };
    }
  }

  return { ...rest };
};

export default useQuery;
